module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_green_02-de4380f1cb2741dcac31bd70f8cdb76a.svg";